import React, { useState } from "react";
import { Button, Modal, Image } from "react-bootstrap";
import Parser from "html-react-parser";

function TripDescription(props) {
  // Declare a new state variable, which we'll call "count"
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { data } = props;

  return (
    <>
      <div style={{ paddingTop: "50px" }}>
        <h1 className="widget-title">{Parser(data.title)}</h1>
        <Image
          className=""
          style={{ padding: "20px 0" }}
          src={data.about_the_trip_image}
          fluid
        />
        {data.paragraphs.map((item, i) => {
          return <p key={`TripDescription-${i}`}>{Parser(item)}</p>;
        })}
      </div>
      <iframe width="100%" style={{aspectRatio: "16 / 9", width: "100% !important"}} src={data.video_link} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

      <p align="center">
        {" "}
        {data.get_on_list_show && (
          <Button
            variant="primary"
            target="_blank"
            href={data.list_button_link}
            style={{ backgroundColor: "#1b949d" }}
          >
            {data.list_button_name}
          </Button>
        )}
      </p>
    </>
  );
}

export default TripDescription;
